import React from 'react';

export const DevBox = React.lazy(() => import('./DevBox'));
